import React from "react";

import { StoryCard } from "../basic/story-card.js"
import { StoryList } from "../basic/story-list.js"
import { CollectionName } from "../basic/collection-name.js";
import { DfpAd } from "../dfp-ad"

import { wrapCollectionLayout } from "@quintype/components";
import {collectionSection} from './collection-layout-helper';

function ThreeColBase({collection, config, associatedMetadata, stories}) {
  const firstStoryCardConfig = {
    image: true,
    imageAspectRatio: [2, 3]
  }
  const secondStoryCardConfig = {
    image: true,
    imageAspectRatio: [16, 9]
  };
  const  {'show_collection_title': collectionName = true} = associatedMetadata;

  return (
    <div className="three-col component-wrapper" data-test-id = "three-col-component">
      {collectionName ? <CollectionName name={collection.name} type="large" section={collection} /> : null}
      <div className="three-col__items">
        <div className="three-col__item full-image">
          <StoryCard hideSectionName={true} story={stories[0]} type="imageBackground" config={firstStoryCardConfig}/>
        </div>
        <div className="three-col__item two-stories">
          <StoryCard hideSectionName={true} story={stories[1]} config={secondStoryCardConfig}/>
          <StoryCard hideSectionName={true} story={stories[2]}/>
        </div>
        <div className="three-col__item">
          <StoryList stories={stories.slice(3, 8) } />
        </div>
      </div>
      <div className="app-ad app-ad--horizontal">
        <DfpAd adtype="Horizontal-Ad" layoutName="ThreeCol" collectionSlug={collection.slug}/>
      </div>
    </div>
  )
}

export const ThreeCol = wrapCollectionLayout(ThreeColBase);
